export const TELEGRAM_URL = 'https://t.me/+MUeHGk3RnIs2MmQ6';